export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/cloud-03.8fc1c808-80ae84.svg";